import { useCurrentUser } from '@hooks';
import { useNavigate } from 'react-router-dom';
export const FullUserBoundary = ({ redirect, children }) => {
    const { isReadOnly } = useCurrentUser();
    const navigate = useNavigate();
    if (isReadOnly) {
        if (!redirect) {
            return null;
        }
        navigate(redirect);
    }
    return children;
};
